import * as actionTypes from "../actions/actionTypes";

const initialState = {
    payment: null,
  };
  
  const getPaymentUrlReducer = (state = initialState, action) => {
    console.log("action.payload",action.payload);
    
    switch (action.type) {
      case actionTypes.GET_PAYMENT_URL:
        return {
          ...state,
          payment: action.payload[0], // store directly
        };
      default:
        return state;
    }
  };
  
  export default getPaymentUrlReducer;
  